/* eslint-disable */

// @ts-nocheck

// noinspection JSUnusedGlobalSymbols

// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from "./routes/__root";
import { Route as IndexRouteImport } from "./routes/index";
import { Route as AuthedRouteImport } from "./routes/_authed";
import { Route as LoginRouteImport } from "./routes/login";
import { Route as AuthedMemberRouteImport } from "./routes/_authed/_member";
import { Route as AuthedOnboardingRouteImport } from "./routes/_authed/onboarding";
import { Route as AuthedMemberAllRouteImport } from "./routes/_authed/_member/all";
import { Route as AuthedMemberArchiveRouteImport } from "./routes/_authed/_member/archive";
import { Route as AuthedMemberComposeRouteImport } from "./routes/_authed/_member/compose";
import { Route as AuthedMemberDoneRouteImport } from "./routes/_authed/_member/done";
import { Route as AuthedMemberInboxRouteImport } from "./routes/_authed/_member/inbox";
import { Route as AuthedMemberQueueRouteImport } from "./routes/_authed/_member/queue";
import { Route as AuthedMemberSearchRouteImport } from "./routes/_authed/_member/search";
import { Route as AuthedInviteInvitationIdRouteImport } from "./routes/_authed/invite.$invitationId";
import { Route as AuthedMemberAllThreadIdRouteImport } from "./routes/_authed/_member/all.$threadId";
import { Route as AuthedMemberArchiveThreadIdRouteImport } from "./routes/_authed/_member/archive.$threadId";
import { Route as AuthedMemberDoneThreadIdRouteImport } from "./routes/_authed/_member/done.$threadId";
import { Route as AuthedMemberInboxThreadIdRouteImport } from "./routes/_authed/_member/inbox.$threadId";
import { Route as AuthedMemberQueueThreadIdRouteImport } from "./routes/_authed/_member/queue.$threadId";
import { Route as AuthedMemberSearchThreadIdRouteImport } from "./routes/_authed/_member/search.$threadId";
import { Route as AuthedMemberSettingsIndexRouteImport } from "./routes/_authed/_member/settings/index";
import { Route as AuthedMemberSettingsBillingRouteImport } from "./routes/_authed/_member/settings/billing";
import { Route as AuthedSettingsEmailsVerifyRouteImport } from "./routes/_authed/settings/emails.verify";

const IndexRoute = IndexRouteImport.update({
  id: "/",
  path: "/",
  getParentRoute: () => rootRouteImport,
} as any);
const AuthedRoute = AuthedRouteImport.update({
  id: "/_authed",
  getParentRoute: () => rootRouteImport,
} as any);
const LoginRoute = LoginRouteImport.update({
  id: "/login",
  path: "/login",
  getParentRoute: () => rootRouteImport,
} as any);
const AuthedMemberRoute = AuthedMemberRouteImport.update({
  id: "/_member",
  getParentRoute: () => AuthedRoute,
} as any);
const AuthedOnboardingRoute = AuthedOnboardingRouteImport.update({
  id: "/onboarding",
  path: "/onboarding",
  getParentRoute: () => AuthedRoute,
} as any);
const AuthedMemberAllRoute = AuthedMemberAllRouteImport.update({
  id: "/all",
  path: "/all",
  getParentRoute: () => AuthedMemberRoute,
} as any);
const AuthedMemberArchiveRoute = AuthedMemberArchiveRouteImport.update({
  id: "/archive",
  path: "/archive",
  getParentRoute: () => AuthedMemberRoute,
} as any);
const AuthedMemberComposeRoute = AuthedMemberComposeRouteImport.update({
  id: "/compose",
  path: "/compose",
  getParentRoute: () => AuthedMemberRoute,
} as any);
const AuthedMemberDoneRoute = AuthedMemberDoneRouteImport.update({
  id: "/done",
  path: "/done",
  getParentRoute: () => AuthedMemberRoute,
} as any);
const AuthedMemberInboxRoute = AuthedMemberInboxRouteImport.update({
  id: "/inbox",
  path: "/inbox",
  getParentRoute: () => AuthedMemberRoute,
} as any);
const AuthedMemberQueueRoute = AuthedMemberQueueRouteImport.update({
  id: "/queue",
  path: "/queue",
  getParentRoute: () => AuthedMemberRoute,
} as any);
const AuthedMemberSearchRoute = AuthedMemberSearchRouteImport.update({
  id: "/search",
  path: "/search",
  getParentRoute: () => AuthedMemberRoute,
} as any);
const AuthedInviteInvitationIdRoute =
  AuthedInviteInvitationIdRouteImport.update({
    id: "/invite/$invitationId",
    path: "/invite/$invitationId",
    getParentRoute: () => AuthedRoute,
  } as any);
const AuthedMemberAllThreadIdRoute = AuthedMemberAllThreadIdRouteImport.update({
  id: "/$threadId",
  path: "/$threadId",
  getParentRoute: () => AuthedMemberAllRoute,
} as any);
const AuthedMemberArchiveThreadIdRoute =
  AuthedMemberArchiveThreadIdRouteImport.update({
    id: "/$threadId",
    path: "/$threadId",
    getParentRoute: () => AuthedMemberArchiveRoute,
  } as any);
const AuthedMemberDoneThreadIdRoute =
  AuthedMemberDoneThreadIdRouteImport.update({
    id: "/$threadId",
    path: "/$threadId",
    getParentRoute: () => AuthedMemberDoneRoute,
  } as any);
const AuthedMemberInboxThreadIdRoute =
  AuthedMemberInboxThreadIdRouteImport.update({
    id: "/$threadId",
    path: "/$threadId",
    getParentRoute: () => AuthedMemberInboxRoute,
  } as any);
const AuthedMemberQueueThreadIdRoute =
  AuthedMemberQueueThreadIdRouteImport.update({
    id: "/$threadId",
    path: "/$threadId",
    getParentRoute: () => AuthedMemberQueueRoute,
  } as any);
const AuthedMemberSearchThreadIdRoute =
  AuthedMemberSearchThreadIdRouteImport.update({
    id: "/$threadId",
    path: "/$threadId",
    getParentRoute: () => AuthedMemberSearchRoute,
  } as any);
const AuthedMemberSettingsIndexRoute =
  AuthedMemberSettingsIndexRouteImport.update({
    id: "/settings/",
    path: "/settings/",
    getParentRoute: () => AuthedMemberRoute,
  } as any);
const AuthedMemberSettingsBillingRoute =
  AuthedMemberSettingsBillingRouteImport.update({
    id: "/settings/billing",
    path: "/settings/billing",
    getParentRoute: () => AuthedMemberRoute,
  } as any);
const AuthedSettingsEmailsVerifyRoute =
  AuthedSettingsEmailsVerifyRouteImport.update({
    id: "/settings/emails/verify",
    path: "/settings/emails/verify",
    getParentRoute: () => AuthedRoute,
  } as any);

export interface FileRoutesByFullPath {
  "/": typeof IndexRoute;
  "/login": typeof LoginRoute;
  "/onboarding": typeof AuthedOnboardingRoute;
  "/all": typeof AuthedMemberAllRouteWithChildren;
  "/archive": typeof AuthedMemberArchiveRouteWithChildren;
  "/compose": typeof AuthedMemberComposeRoute;
  "/done": typeof AuthedMemberDoneRouteWithChildren;
  "/inbox": typeof AuthedMemberInboxRouteWithChildren;
  "/queue": typeof AuthedMemberQueueRouteWithChildren;
  "/search": typeof AuthedMemberSearchRouteWithChildren;
  "/invite/$invitationId": typeof AuthedInviteInvitationIdRoute;
  "/all/$threadId": typeof AuthedMemberAllThreadIdRoute;
  "/archive/$threadId": typeof AuthedMemberArchiveThreadIdRoute;
  "/done/$threadId": typeof AuthedMemberDoneThreadIdRoute;
  "/inbox/$threadId": typeof AuthedMemberInboxThreadIdRoute;
  "/queue/$threadId": typeof AuthedMemberQueueThreadIdRoute;
  "/search/$threadId": typeof AuthedMemberSearchThreadIdRoute;
  "/settings/billing": typeof AuthedMemberSettingsBillingRoute;
  "/settings/emails/verify": typeof AuthedSettingsEmailsVerifyRoute;
  "/settings/": typeof AuthedMemberSettingsIndexRoute;
}
export interface FileRoutesByTo {
  "/": typeof IndexRoute;
  "/login": typeof LoginRoute;
  "/onboarding": typeof AuthedOnboardingRoute;
  "/all": typeof AuthedMemberAllRouteWithChildren;
  "/archive": typeof AuthedMemberArchiveRouteWithChildren;
  "/compose": typeof AuthedMemberComposeRoute;
  "/done": typeof AuthedMemberDoneRouteWithChildren;
  "/inbox": typeof AuthedMemberInboxRouteWithChildren;
  "/queue": typeof AuthedMemberQueueRouteWithChildren;
  "/search": typeof AuthedMemberSearchRouteWithChildren;
  "/invite/$invitationId": typeof AuthedInviteInvitationIdRoute;
  "/all/$threadId": typeof AuthedMemberAllThreadIdRoute;
  "/archive/$threadId": typeof AuthedMemberArchiveThreadIdRoute;
  "/done/$threadId": typeof AuthedMemberDoneThreadIdRoute;
  "/inbox/$threadId": typeof AuthedMemberInboxThreadIdRoute;
  "/queue/$threadId": typeof AuthedMemberQueueThreadIdRoute;
  "/search/$threadId": typeof AuthedMemberSearchThreadIdRoute;
  "/settings/billing": typeof AuthedMemberSettingsBillingRoute;
  "/settings/emails/verify": typeof AuthedSettingsEmailsVerifyRoute;
  "/settings": typeof AuthedMemberSettingsIndexRoute;
}
export interface FileRoutesById {
  __root__: typeof rootRouteImport;
  "/": typeof IndexRoute;
  "/_authed": typeof AuthedRouteWithChildren;
  "/login": typeof LoginRoute;
  "/_authed/_member": typeof AuthedMemberRouteWithChildren;
  "/_authed/onboarding": typeof AuthedOnboardingRoute;
  "/_authed/_member/all": typeof AuthedMemberAllRouteWithChildren;
  "/_authed/_member/archive": typeof AuthedMemberArchiveRouteWithChildren;
  "/_authed/_member/compose": typeof AuthedMemberComposeRoute;
  "/_authed/_member/done": typeof AuthedMemberDoneRouteWithChildren;
  "/_authed/_member/inbox": typeof AuthedMemberInboxRouteWithChildren;
  "/_authed/_member/queue": typeof AuthedMemberQueueRouteWithChildren;
  "/_authed/_member/search": typeof AuthedMemberSearchRouteWithChildren;
  "/_authed/invite/$invitationId": typeof AuthedInviteInvitationIdRoute;
  "/_authed/_member/all/$threadId": typeof AuthedMemberAllThreadIdRoute;
  "/_authed/_member/archive/$threadId": typeof AuthedMemberArchiveThreadIdRoute;
  "/_authed/_member/done/$threadId": typeof AuthedMemberDoneThreadIdRoute;
  "/_authed/_member/inbox/$threadId": typeof AuthedMemberInboxThreadIdRoute;
  "/_authed/_member/queue/$threadId": typeof AuthedMemberQueueThreadIdRoute;
  "/_authed/_member/search/$threadId": typeof AuthedMemberSearchThreadIdRoute;
  "/_authed/_member/settings/billing": typeof AuthedMemberSettingsBillingRoute;
  "/_authed/settings/emails/verify": typeof AuthedSettingsEmailsVerifyRoute;
  "/_authed/_member/settings/": typeof AuthedMemberSettingsIndexRoute;
}
export interface FileRouteTypes {
  fileRoutesByFullPath: FileRoutesByFullPath;
  fullPaths:
    | "/"
    | "/login"
    | "/onboarding"
    | "/all"
    | "/archive"
    | "/compose"
    | "/done"
    | "/inbox"
    | "/queue"
    | "/search"
    | "/invite/$invitationId"
    | "/all/$threadId"
    | "/archive/$threadId"
    | "/done/$threadId"
    | "/inbox/$threadId"
    | "/queue/$threadId"
    | "/search/$threadId"
    | "/settings/billing"
    | "/settings/emails/verify"
    | "/settings/";
  fileRoutesByTo: FileRoutesByTo;
  to:
    | "/"
    | "/login"
    | "/onboarding"
    | "/all"
    | "/archive"
    | "/compose"
    | "/done"
    | "/inbox"
    | "/queue"
    | "/search"
    | "/invite/$invitationId"
    | "/all/$threadId"
    | "/archive/$threadId"
    | "/done/$threadId"
    | "/inbox/$threadId"
    | "/queue/$threadId"
    | "/search/$threadId"
    | "/settings/billing"
    | "/settings/emails/verify"
    | "/settings";
  id:
    | "__root__"
    | "/"
    | "/_authed"
    | "/login"
    | "/_authed/_member"
    | "/_authed/onboarding"
    | "/_authed/_member/all"
    | "/_authed/_member/archive"
    | "/_authed/_member/compose"
    | "/_authed/_member/done"
    | "/_authed/_member/inbox"
    | "/_authed/_member/queue"
    | "/_authed/_member/search"
    | "/_authed/invite/$invitationId"
    | "/_authed/_member/all/$threadId"
    | "/_authed/_member/archive/$threadId"
    | "/_authed/_member/done/$threadId"
    | "/_authed/_member/inbox/$threadId"
    | "/_authed/_member/queue/$threadId"
    | "/_authed/_member/search/$threadId"
    | "/_authed/_member/settings/billing"
    | "/_authed/settings/emails/verify"
    | "/_authed/_member/settings/";
  fileRoutesById: FileRoutesById;
}
export interface RootRouteChildren {
  IndexRoute: typeof IndexRoute;
  AuthedRoute: typeof AuthedRouteWithChildren;
  LoginRoute: typeof LoginRoute;
}

declare module "@tanstack/react-router" {
  interface FileRoutesByPath {
    "/": {
      id: "/";
      path: "/";
      fullPath: "/";
      preLoaderRoute: typeof IndexRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_authed": {
      id: "/_authed";
      path: "";
      fullPath: "/";
      preLoaderRoute: typeof AuthedRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/login": {
      id: "/login";
      path: "/login";
      fullPath: "/login";
      preLoaderRoute: typeof LoginRouteImport;
      parentRoute: typeof rootRouteImport;
    };
    "/_authed/_member": {
      id: "/_authed/_member";
      path: "";
      fullPath: "/";
      preLoaderRoute: typeof AuthedMemberRouteImport;
      parentRoute: typeof AuthedRoute;
    };
    "/_authed/onboarding": {
      id: "/_authed/onboarding";
      path: "/onboarding";
      fullPath: "/onboarding";
      preLoaderRoute: typeof AuthedOnboardingRouteImport;
      parentRoute: typeof AuthedRoute;
    };
    "/_authed/_member/all": {
      id: "/_authed/_member/all";
      path: "/all";
      fullPath: "/all";
      preLoaderRoute: typeof AuthedMemberAllRouteImport;
      parentRoute: typeof AuthedMemberRoute;
    };
    "/_authed/_member/archive": {
      id: "/_authed/_member/archive";
      path: "/archive";
      fullPath: "/archive";
      preLoaderRoute: typeof AuthedMemberArchiveRouteImport;
      parentRoute: typeof AuthedMemberRoute;
    };
    "/_authed/_member/compose": {
      id: "/_authed/_member/compose";
      path: "/compose";
      fullPath: "/compose";
      preLoaderRoute: typeof AuthedMemberComposeRouteImport;
      parentRoute: typeof AuthedMemberRoute;
    };
    "/_authed/_member/done": {
      id: "/_authed/_member/done";
      path: "/done";
      fullPath: "/done";
      preLoaderRoute: typeof AuthedMemberDoneRouteImport;
      parentRoute: typeof AuthedMemberRoute;
    };
    "/_authed/_member/inbox": {
      id: "/_authed/_member/inbox";
      path: "/inbox";
      fullPath: "/inbox";
      preLoaderRoute: typeof AuthedMemberInboxRouteImport;
      parentRoute: typeof AuthedMemberRoute;
    };
    "/_authed/_member/queue": {
      id: "/_authed/_member/queue";
      path: "/queue";
      fullPath: "/queue";
      preLoaderRoute: typeof AuthedMemberQueueRouteImport;
      parentRoute: typeof AuthedMemberRoute;
    };
    "/_authed/_member/search": {
      id: "/_authed/_member/search";
      path: "/search";
      fullPath: "/search";
      preLoaderRoute: typeof AuthedMemberSearchRouteImport;
      parentRoute: typeof AuthedMemberRoute;
    };
    "/_authed/invite/$invitationId": {
      id: "/_authed/invite/$invitationId";
      path: "/invite/$invitationId";
      fullPath: "/invite/$invitationId";
      preLoaderRoute: typeof AuthedInviteInvitationIdRouteImport;
      parentRoute: typeof AuthedRoute;
    };
    "/_authed/_member/all/$threadId": {
      id: "/_authed/_member/all/$threadId";
      path: "/$threadId";
      fullPath: "/all/$threadId";
      preLoaderRoute: typeof AuthedMemberAllThreadIdRouteImport;
      parentRoute: typeof AuthedMemberAllRoute;
    };
    "/_authed/_member/archive/$threadId": {
      id: "/_authed/_member/archive/$threadId";
      path: "/$threadId";
      fullPath: "/archive/$threadId";
      preLoaderRoute: typeof AuthedMemberArchiveThreadIdRouteImport;
      parentRoute: typeof AuthedMemberArchiveRoute;
    };
    "/_authed/_member/done/$threadId": {
      id: "/_authed/_member/done/$threadId";
      path: "/$threadId";
      fullPath: "/done/$threadId";
      preLoaderRoute: typeof AuthedMemberDoneThreadIdRouteImport;
      parentRoute: typeof AuthedMemberDoneRoute;
    };
    "/_authed/_member/inbox/$threadId": {
      id: "/_authed/_member/inbox/$threadId";
      path: "/$threadId";
      fullPath: "/inbox/$threadId";
      preLoaderRoute: typeof AuthedMemberInboxThreadIdRouteImport;
      parentRoute: typeof AuthedMemberInboxRoute;
    };
    "/_authed/_member/queue/$threadId": {
      id: "/_authed/_member/queue/$threadId";
      path: "/$threadId";
      fullPath: "/queue/$threadId";
      preLoaderRoute: typeof AuthedMemberQueueThreadIdRouteImport;
      parentRoute: typeof AuthedMemberQueueRoute;
    };
    "/_authed/_member/search/$threadId": {
      id: "/_authed/_member/search/$threadId";
      path: "/$threadId";
      fullPath: "/search/$threadId";
      preLoaderRoute: typeof AuthedMemberSearchThreadIdRouteImport;
      parentRoute: typeof AuthedMemberSearchRoute;
    };
    "/_authed/_member/settings/": {
      id: "/_authed/_member/settings/";
      path: "/settings";
      fullPath: "/settings/";
      preLoaderRoute: typeof AuthedMemberSettingsIndexRouteImport;
      parentRoute: typeof AuthedMemberRoute;
    };
    "/_authed/_member/settings/billing": {
      id: "/_authed/_member/settings/billing";
      path: "/settings/billing";
      fullPath: "/settings/billing";
      preLoaderRoute: typeof AuthedMemberSettingsBillingRouteImport;
      parentRoute: typeof AuthedMemberRoute;
    };
    "/_authed/settings/emails/verify": {
      id: "/_authed/settings/emails/verify";
      path: "/settings/emails/verify";
      fullPath: "/settings/emails/verify";
      preLoaderRoute: typeof AuthedSettingsEmailsVerifyRouteImport;
      parentRoute: typeof AuthedRoute;
    };
  }
}

interface AuthedMemberAllRouteChildren {
  AuthedMemberAllThreadIdRoute: typeof AuthedMemberAllThreadIdRoute;
}

const AuthedMemberAllRouteChildren: AuthedMemberAllRouteChildren = {
  AuthedMemberAllThreadIdRoute: AuthedMemberAllThreadIdRoute,
};

const AuthedMemberAllRouteWithChildren = AuthedMemberAllRoute._addFileChildren(
  AuthedMemberAllRouteChildren,
);

interface AuthedMemberArchiveRouteChildren {
  AuthedMemberArchiveThreadIdRoute: typeof AuthedMemberArchiveThreadIdRoute;
}

const AuthedMemberArchiveRouteChildren: AuthedMemberArchiveRouteChildren = {
  AuthedMemberArchiveThreadIdRoute: AuthedMemberArchiveThreadIdRoute,
};

const AuthedMemberArchiveRouteWithChildren =
  AuthedMemberArchiveRoute._addFileChildren(AuthedMemberArchiveRouteChildren);

interface AuthedMemberDoneRouteChildren {
  AuthedMemberDoneThreadIdRoute: typeof AuthedMemberDoneThreadIdRoute;
}

const AuthedMemberDoneRouteChildren: AuthedMemberDoneRouteChildren = {
  AuthedMemberDoneThreadIdRoute: AuthedMemberDoneThreadIdRoute,
};

const AuthedMemberDoneRouteWithChildren =
  AuthedMemberDoneRoute._addFileChildren(AuthedMemberDoneRouteChildren);

interface AuthedMemberInboxRouteChildren {
  AuthedMemberInboxThreadIdRoute: typeof AuthedMemberInboxThreadIdRoute;
}

const AuthedMemberInboxRouteChildren: AuthedMemberInboxRouteChildren = {
  AuthedMemberInboxThreadIdRoute: AuthedMemberInboxThreadIdRoute,
};

const AuthedMemberInboxRouteWithChildren =
  AuthedMemberInboxRoute._addFileChildren(AuthedMemberInboxRouteChildren);

interface AuthedMemberQueueRouteChildren {
  AuthedMemberQueueThreadIdRoute: typeof AuthedMemberQueueThreadIdRoute;
}

const AuthedMemberQueueRouteChildren: AuthedMemberQueueRouteChildren = {
  AuthedMemberQueueThreadIdRoute: AuthedMemberQueueThreadIdRoute,
};

const AuthedMemberQueueRouteWithChildren =
  AuthedMemberQueueRoute._addFileChildren(AuthedMemberQueueRouteChildren);

interface AuthedMemberSearchRouteChildren {
  AuthedMemberSearchThreadIdRoute: typeof AuthedMemberSearchThreadIdRoute;
}

const AuthedMemberSearchRouteChildren: AuthedMemberSearchRouteChildren = {
  AuthedMemberSearchThreadIdRoute: AuthedMemberSearchThreadIdRoute,
};

const AuthedMemberSearchRouteWithChildren =
  AuthedMemberSearchRoute._addFileChildren(AuthedMemberSearchRouteChildren);

interface AuthedMemberRouteChildren {
  AuthedMemberAllRoute: typeof AuthedMemberAllRouteWithChildren;
  AuthedMemberArchiveRoute: typeof AuthedMemberArchiveRouteWithChildren;
  AuthedMemberComposeRoute: typeof AuthedMemberComposeRoute;
  AuthedMemberDoneRoute: typeof AuthedMemberDoneRouteWithChildren;
  AuthedMemberInboxRoute: typeof AuthedMemberInboxRouteWithChildren;
  AuthedMemberQueueRoute: typeof AuthedMemberQueueRouteWithChildren;
  AuthedMemberSearchRoute: typeof AuthedMemberSearchRouteWithChildren;
  AuthedMemberSettingsBillingRoute: typeof AuthedMemberSettingsBillingRoute;
  AuthedMemberSettingsIndexRoute: typeof AuthedMemberSettingsIndexRoute;
}

const AuthedMemberRouteChildren: AuthedMemberRouteChildren = {
  AuthedMemberAllRoute: AuthedMemberAllRouteWithChildren,
  AuthedMemberArchiveRoute: AuthedMemberArchiveRouteWithChildren,
  AuthedMemberComposeRoute: AuthedMemberComposeRoute,
  AuthedMemberDoneRoute: AuthedMemberDoneRouteWithChildren,
  AuthedMemberInboxRoute: AuthedMemberInboxRouteWithChildren,
  AuthedMemberQueueRoute: AuthedMemberQueueRouteWithChildren,
  AuthedMemberSearchRoute: AuthedMemberSearchRouteWithChildren,
  AuthedMemberSettingsBillingRoute: AuthedMemberSettingsBillingRoute,
  AuthedMemberSettingsIndexRoute: AuthedMemberSettingsIndexRoute,
};

const AuthedMemberRouteWithChildren = AuthedMemberRoute._addFileChildren(
  AuthedMemberRouteChildren,
);

interface AuthedRouteChildren {
  AuthedMemberRoute: typeof AuthedMemberRouteWithChildren;
  AuthedOnboardingRoute: typeof AuthedOnboardingRoute;
  AuthedInviteInvitationIdRoute: typeof AuthedInviteInvitationIdRoute;
  AuthedSettingsEmailsVerifyRoute: typeof AuthedSettingsEmailsVerifyRoute;
}

const AuthedRouteChildren: AuthedRouteChildren = {
  AuthedMemberRoute: AuthedMemberRouteWithChildren,
  AuthedOnboardingRoute: AuthedOnboardingRoute,
  AuthedInviteInvitationIdRoute: AuthedInviteInvitationIdRoute,
  AuthedSettingsEmailsVerifyRoute: AuthedSettingsEmailsVerifyRoute,
};

const AuthedRouteWithChildren =
  AuthedRoute._addFileChildren(AuthedRouteChildren);

const rootRouteChildren: RootRouteChildren = {
  IndexRoute: IndexRoute,
  AuthedRoute: AuthedRouteWithChildren,
  LoginRoute: LoginRoute,
};
export const routeTree = rootRouteImport
  ._addFileChildren(rootRouteChildren)
  ._addFileTypes<FileRouteTypes>();
